import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import homeLogo from "../../Assets/home-main.svg";
import Particle from "../Particle";
import Home2 from "./Home2";
import Type from "./Type";

function Home() {
  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Particle />
        <Container className="home-content">
          <Row>
            <Col md={7} className="home-header">
              <h1 style={{ paddingBottom: 15 }} className="heading">
                Hi There!{" "}
                <span className="wave" role="img" aria-labelledby="wave">
                  👋🏻
                </span>
              </h1>

              <h1 className="heading-name">
                I'M
                <strong className="main-name"> NAVEEN KUMAR</strong>
              </h1>

              <div style={{ padding: "50px 50px 0 50px", textAlign: "left" }}>
                <Type />
                <div style={{ marginTop: "40px" }} className="hero-cta-container">
                  <Button
                    as={Link}
                    to="/project"
                    variant="primary"
                    className="hero-cta-btn me-3"
                  >
                    View My Works
                  </Button>
                  <Button
                    as={Link}
                    to="/contact"
                    variant="outline-primary"
                    className="hero-cta-btn cta-outline"
                  >
                    Contact Me
                  </Button>
                </div>
              </div>
            </Col>

            <Col md={5} style={{ paddingBottom: 20 }}>
              <img
                src={homeLogo}
                alt="home pic"
                className="img-fluid"
                style={{ maxHeight: "450px" }}
              />
            </Col>
          </Row>
        </Container>
      </Container>
      <Home2 />
    </section>
  );
}

export default Home;
